import React from "react"
import {SELFIE_STATE, SelfieUploadProvider, useSelfieUploadState} from "./selfie_context";
import {Instructions} from "./pages/instructions";
import {CameraRecording} from "./pages/camera_recording";
import {FileSelect} from "./components/file_select";
import {Pintura} from "./pages/pintura";
import {Preview} from "./pages/preview";
import {ThankYou} from "./pages/thank_you";
import {Upload} from "./pages/upload";
import {MediaSourceSelect} from "./pages/media_source_select";

const SelfieUploadContent = () => {
  const {
    state,
    selectionMode,
    mode,
  } = useSelfieUploadState()

  switch (state) {
    case SELFIE_STATE.MEDIA_INPUT:
      switch (selectionMode) {
        case 'file':
          return <FileSelect/>
        case 'camera':
          return <CameraRecording/>
        case 'all':
        default:
          return <MediaSourceSelect/>
      }
    case SELFIE_STATE.INSTRUCTIONS:
      return <Instructions/>
    case SELFIE_STATE.PINTURA:
      return <Pintura/>
    case SELFIE_STATE.PREVIEW:
      return <Preview/>
    case SELFIE_STATE.THANK_YOU:
      return <ThankYou/>
    case SELFIE_STATE.UPLOAD:
      return <Upload/>
  }
}

/**
 * @param {Object} props - The props object.
 * @param {'file'|'camera'|'all'} props.selectionMode
 * @param {'video'|'image'} props.mode
 * @param {number} props.maxVideoLengthSeconds
 * @param {string} props.uploadFileIdentifier
 * @param {string|null} props.pinturaConfig
 * @param {React.ReactNode} props.thankYou
 * @param {number} props.targetWidth
 * @param {number} props.targetHeight
 * @param {'user'|'environment'} props.facingMode
 * @param {'media_files'|'tag_owner_images'|'stored_photos'} props.pictureMode Determines as what images/videos are uploaded
 * @param {'vertical'|'horizontal'|null} props.mediaSelectButtonOrientation
 * @param {boolean} props.showUploadConfirmation
 * @param {string} props.overlayMediaFileId
 * @returns {JSX.Element} React component.
 */
export const SelfieUpload = (
  {
    selectionMode,
    mode = 'image',
    maxVideoLengthSeconds,
    uploadFileIdentifier,
    pinturaConfig,
    thankYou,
    targetWidth,
    targetHeight,
    facingMode,
    pictureMode= "stored_photos",
    mediaSelectButtonOrientation,
    showUploadConfirmation,
    overlayMediaFileId,
  }
) => {
  return <SelfieUploadProvider
    selectionMode={selectionMode || 'all'}
    mode={mode || 'image'}
    maxVideoLengthSeconds={maxVideoLengthSeconds || 5}
    uploadFileIdentifier={uploadFileIdentifier || "selfie"}
    pinturaConfig={pinturaConfig || null}
    thankYou={thankYou || "Thank you!"}
    targetWidth={targetWidth || 1920}
    targetHeight={targetHeight || 1080}
    facingMode={facingMode || "user"}
    mediaSelectButtonOrientation={mediaSelectButtonOrientation || "vertical"}
    pictureMode={pictureMode}
    showUploadConfirmation={showUploadConfirmation}
    overlayMediaFileId={overlayMediaFileId}
  >
    <SelfieUploadContent/>
  </SelfieUploadProvider>
}